import { intl } from "LocaleWrapper";
import { MouseEvent, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVert from "@mui/icons-material/MoreVert";

type WidgetMenuProps = {
	onEdit: () => void;
	onDelete: () => void;
};

const WidgetMenu = ({ onEdit, onDelete }: WidgetMenuProps) => {
	const [ anchor, setAnchor ] = useState<HTMLElement | null>(null);

	const cancelClick = (event: MouseEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
	};

	const open = (event: MouseEvent<HTMLElement>) => {
		cancelClick(event);
		setAnchor(event.currentTarget);
	};

	const choose = (action: () => void) => (event: MouseEvent<HTMLElement>) => {
		cancelClick(event);
		setAnchor(null);
		action();
	};

	return <>
		<IconButton size="small" onClick={open}>
			<MoreVert fontSize="small" />
		</IconButton>

		<Menu
			anchorEl={anchor}
			open={Boolean(anchor)}
			onClose={() => setAnchor(null)}
			onClick={cancelClick}>
			<MenuItem onClick={choose(onEdit)}>{intl.formatMessage({ id: "EDIT" })}</MenuItem>
			<MenuItem onClick={choose(onDelete)}>{intl.formatMessage({ id: "DELETE" })}</MenuItem>
		</Menu>
	</>;
};

export default WidgetMenu;
